<template>
  <div class="news-style-detail">
        <!-- <newsHeader :page="'优秀学员'"></newsHeader> -->
        <!-- <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news/style' }">优秀学员</el-breadcrumb-item>
            <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <div class="word_info">
                            <div class="video_wrap flex-column-between">
                                <div class="video">
                                    <video :src="article.video" controls="controls" autoplay="autoplay">您的浏览器不支持 video 标签。</video>
                                </div>
                                <div class="video_title flex-align-between">
                                    <!-- <img src="@/assets/home/video_title.png" /> -->
                                    <div style="width:6px;height:100%;background:#1C4B90;margin-right:3px"></div>
                                </div>
                            </div>
                        </div>

                        <p class="source f12">
                            <span> 来源：{{article.source}}</span> 
                            <span> 作者：{{article.author}} </span>
                            <span> 责任编辑：{{article.editor}}</span> 
                            <!-- <span> 责任编辑：张璐 </span> -->
                        </p>
                        <p class="other-info f12 flex-layout">
                            <span>{{article.updateTime}}</span>
                            <span class="eye">{{article.views}}</span>
                        </p>
                    </div>
                    <div class="content" v-html="article.content">
                         <!-- <p>
                             为全力做好疫情防控及应急处置工作，切实保障师生员工的健康和安全，
                            6月5日上午，我校组织开展学生返校演练。学校返校复课领导小组组长、
                            党委书记郑萼、校长孟繁华，领导小组成员、副校长杨志成、纪委书记李中奇、
                            副校长李有增、副校长马力耕、北京教育系统疫情防控工作领导小组驻我校联络员于杰进行观摩。
                            演练由党委副书记缪劲翔主持。
                        </p>
                        <p>
                            首先，孟繁华作返校演练动员讲话。
                            他表示，此次演练是对近期学校疫情防控工作的整体考核，
                            也是全面做好返校复学工作的关键一环。全校各单位要提高政治站位，
                            扎实守好每一个关口，树立“演练即是实战”思想，摸清问题短板，不断完善流程。
                            各单位、全体师生员工要同心同德、齐心协力，层层压实责任，营造良好氛围，
                            强化联防联控机制，举全校之力，迎接学生“回家”。
                         </p>
                        <img src="" alt=""> -->
                    </div>
                    <div class="pagination flex-align-between">
                       <p class="pv wes" :class="[!prev.id? 'not-hover' : '']" @click="toPage(prev)">上一篇：{{prev.id ? prev.title :'无'}}</p>
                       <p class="next wes" :class="[!next.id? 'not-hover' : '']" @click="toPage(next)">下一篇：{{next.id ? next.title :'无'}}</p>
                    </div>
                   
                </div>
            </div>
            <div class="news_detail_right">
                <div class="subtitle flex-align-between">
                    <h2 class="text text-first f16 flex-align">最新推荐</h2>
                </div>
                <div class="timeline-list">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        type="primary"
                        color="#BEE3FF"
                        size="large"
                        :timestamp="activity.detailCreateTime"
                        class="timeline-item">
                        <p class="f12">{{activity.detailCreateTime}}</p>
                        <p class="f12">{{activity.introduction}}</p>
                      </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <scorllTop :share="false"></scorllTop>
  </div>
</template>

<script>
export default {
    data() {
        return {
        article:{},
        prev:{},
        next:{},
        hasHover:false,
        activities: [{
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        },
        {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师京-银川”“互联京-银川”“互联京-银川”“互联范大学“双优云桥',
          },
          color: '#BEE3FF'
        }]
        }
    },
     watch: {
        // '$route': function(to,from){
        //     document.body.scrollTop = 0
        //     document.documentElement.scrollTop = 0
        //     this.getArticle();
        //     this.getRecommend();
        // }
    },
    computed:{

    },
    methods:{
        async getArticle() {
            console.log(this.$route.params.id)
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetStyleDetail(params);
            this.article = resData.data;
            // console.log(resData);
        },
        async getRecommend() {
            let resData = await Api.News.GetNewsRecommend()
            // console.log(resData);
            this.activities = resData.data;
        },
        async getNearInfo () {
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetStyleNear(params);
            this.prev = resData.data[0];
            this.next = resData.data[1];
            console.log(resData);
        },
        toPage(item){
            console.log(item)
            if(item.id !== undefined) {
                Common.goPage(`/news/style/detail/${item.id}`,this)
            } 
        }
    },
    mounted(){
        this.getArticle();
        this.getRecommend();
        this.getNearInfo();
    },
}
</script>

<style lang="less">
    @import "../less/news_headlines_detail.less";

    .news-style-detail {
        .news_detail_left  {
            .title-box {
                border-bottom: 0;
            }

            h3 {
                border-bottom: 1px solid #e4e4e4;
                padding-bottom: 20px;
            }

            // .source {
            //     margin-top: 23px;
            // }

            .video  video{
                margin: 13px auto 23px;
                width: 740px;
                height: 416px;
            }
        }
    }
</style>